import {
  Box,
  Typography,
  TypographyProps,
  useTheme,
  Theme,
} from "@mui/material";
import { useState } from "react";
import { SummaryData } from "src/store/api/generatedApi";
import { NumberSerialiserOptions } from "hooks/serialisers/types";
import {
  calculateDiff,
  formatBaseValue,
  formatDiffValue,
  getDiffColor,
} from "./utils";

interface FormattedValueResult {
  baseValue: string;
  diffText: string;
  diffColor: string;
}

const formatValueWithDiff = (
  summary: SummaryData,
  formatNumber: (value: number, options?: NumberSerialiserOptions) => string,
  theme: Theme,
  forceOpacity?: number
): FormattedValueResult => {
  const baseValue = formatBaseValue(summary, formatNumber);
  const diff = calculateDiff(summary);
  const diffText = formatDiffValue(
    diff,
    formatNumber,
    summary.decimal_places ?? undefined
  );
  const diffColor = getDiffColor(
    diff,
    summary.value,
    summary.name,
    theme,
    forceOpacity
  );

  return { baseValue, diffText, diffColor };
};

export const ValueWithDiff = ({
  summary,
  formatNumber,
  variant = "inherit",
  hideDiff = false,
}: {
  summary: SummaryData;
  formatNumber: (value: number, options?: NumberSerialiserOptions) => string;
  variant?: TypographyProps["variant"];
  hideDiff?: boolean;
}) => {
  const theme = useTheme();
  const [isHovering, setIsHovering] = useState(false);

  const { baseValue, diffText, diffColor } = formatValueWithDiff(
    summary,
    formatNumber,
    theme,
    isHovering ? 1 : undefined
  );

  return (
    <Typography
      variant={variant}
      sx={{
        whiteSpace: "nowrap",
      }}
      onMouseEnter={() => {
        setIsHovering(true);
      }}
      onMouseLeave={() => {
        setIsHovering(false);
      }}
    >
      {baseValue}
      {!hideDiff ? (
        <Box
          component="span"
          sx={{
            color: diffColor,
            ml: 0.75,
            fontSize: isHovering ? "inherit" : "0.8em",
            cursor: "default",
          }}
        >
          {"(" + diffText + ")"}
        </Box>
      ) : null}
    </Typography>
  );
};
